import { CircularProgress } from '@mui/material';
import { useEffect, useState } from 'react';
import { CURRENCY_SYMBOL } from 'enums/currencySymbols';
import { currencyRatesService } from 'services/currencyRates';

const CurrencyRates = () => {
    const [currencyRates, setCurrencyRates] = useState(null)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null)

    useEffect(() => {
        const loadCurrencyRates = async () => {
            try {
                const r = await currencyRatesService.getAll()
                setCurrencyRates(r)
            } catch (error) {
                setError(error)
            } finally {
                setLoading(false)
            }
        }
        // loadCurrencyRates()
    }, [])

    if (loading) {
        return <div className="text-center"><CircularProgress></CircularProgress></div>
    }

    if (error) {
        return <div className="text-center">Error: {error}</div>
    }

    if (!currencyRates) return <></>

    const USD = currencyRates.find(c => c.title === 'USD')
    const EUR = currencyRates.find(c => c.title === 'EUR')

    return (
        <div className='fs-14 no-mobile flex gap-16'>
            <span>USD: {USD.description} {CURRENCY_SYMBOL.KZT}</span>
            <span>EUR: {EUR.description} {CURRENCY_SYMBOL.KZT}</span>
        </div>
    )
}


export default CurrencyRates